import React, { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { ExitIcon } from '../icons';
import { ErrorIcon } from './icons/ErrorIcon';
import { SuccessCheckmark } from './icons/SuccessCheckmark';

export const TOAST_VARIANT = {
  success: 'Success',
  error: 'Error',
} as const;
export type ToastVariant = keyof typeof TOAST_VARIANT;

const variantIcon: Record<ToastVariant, React.ReactNode> = {
  success: <SuccessCheckmark />,
  error: <ErrorIcon />,
};

export interface ToastProps extends HTMLAttributes<HTMLDivElement> {
  variant: ToastVariant;
  onExit: () => void;
  title?: string;
  description?: string | ReactNode;
}

export const Toast = React.forwardRef<HTMLDivElement, ToastProps>(
  ({ variant, onExit, title, description, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={twMerge('flex items-center justify-between bg-[#081D40] p-6', className)}
      {...rest}
      aria-live="polite"
    >
      <div className="flex items-center text-[#FFFFFF]">
        <div>{variantIcon[variant]}</div>
        <div className="flex flex-col gap-y-2 pl-4">
          {title && <div className="text-base font-bold">{title}</div>}
          {description && <div className="text-sm">{description}</div>}
        </div>
      </div>
      <button type="button" className="cursor-pointer" onClick={onExit} aria-label="Close">
        <ExitIcon data-testid="toast-exit-icon" />
      </button>
    </div>
  ),
);

Toast.displayName = 'Toast';
